import React from 'react';
import {
    OptionContainer,
    AccountFieldTitle,
    AccountFieldAddress,
    OptionalLoadMoreView,
    OuterContainer,
    ImgDiv,
    LineSeparator,
} from './index.styled';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import starimage from 'src/assets/images/Star.svg';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import { useTranslation } from 'react-i18next';

export default function AccountPhysicianTemplate({
    option,
    data,
    fieldname,
    optionValue,
    showOptionLoader = false,
    onLoadMore,
    showLoadMore,
    physiciantype,
    physicianInputValue,
    nameWidth,
    addressWidth,
}) {
    const isAllNotRecentUsed =
        data.filter((element) => !element.recentlyUsed).length === data.length;
    // const isAllFav = isAllNotRecentUsed
    //     ? data.filter((element) => element.favorite).length === data.length
    //     : false;
    let isLasOption = data?.length
        ? data[data.length - 1][optionValue] == option[optionValue]
        : false;
    const { t } = useTranslation();
    return (
        <>
            <OuterContainer isLoadMore={isLasOption} margin display="unset">
                {fieldname != 'account' &&
                option.physicianFirstName === 'Other' &&
                option.physicianLastName === 'Physician' ? null : (
                    <div style={{ display: 'block' }}>
                        <>
                            <OptionContainer padding={'10px 10px 5px 10px'}>
                                <div>
                                    <AccountFieldTitle
                                        width={nameWidth ? nameWidth : '40vw'}
                                        mobileWidth={
                                            nameWidth ? nameWidth : '50vw'
                                        }
                                        iPadwidth={
                                            nameWidth ? nameWidth : '25vw'
                                        }
                                    >
                                        {option.accountName ||
                                            `${option.physicianFirstName} ${option.physicianLastName}`}{' '}
                                    </AccountFieldTitle>
                                    <AccountFieldTitle
                                        margin="0px 5px"
                                        fontFamily="AvenirNextWorld Italic"
                                    >
                                        {fieldname === 'account'
                                            ? accountNumberZeroTrimmer(
                                                  option.accountId || ''
                                              )
                                            : option.surgeonNumber}
                                    </AccountFieldTitle>
                                    <div>
                                        <AccountFieldAddress
                                            width={
                                                addressWidth
                                                    ? addressWidth
                                                    : '30vw'
                                            }
                                            iPadwidth={
                                                addressWidth
                                                    ? addressWidth
                                                    : '18vw'
                                            }
                                            mobileWidth={
                                                addressWidth
                                                    ? addressWidth
                                                    : '30vw'
                                            }
                                        >
                                            {option?.address?.city ||
                                                option.city}
                                            {', '}
                                            {option?.address?.state ||
                                                option.state}
                                        </AccountFieldAddress>
                                        <AccountFieldAddress margin="0px 8px">
                                            |
                                        </AccountFieldAddress>
                                        <AccountFieldAddress
                                            width={
                                                addressWidth
                                                    ? addressWidth
                                                    : option.specialityDesc
                                                    ? '33vw'
                                                    : '35vw'
                                            }
                                            mobileWidth={
                                                addressWidth
                                                    ? addressWidth
                                                    : '32vw'
                                            }
                                            iPadwidth={
                                                addressWidth
                                                    ? addressWidth
                                                    : '15vw'
                                            }
                                        >
                                            {option?.address?.addressLine1 ||
                                                option.specialityDesc}
                                        </AccountFieldAddress>
                                    </div>
                                </div>
                                <ImgDiv>
                                    {option.isFavorite || option.favorite ? (
                                        <img src={starimage} />
                                    ) : null}
                                </ImgDiv>
                            </OptionContainer>
                        </>
                        <LineSeparator></LineSeparator>
                    </div>
                )}
                {physiciantype != 'favorites' &&
                fieldname != 'account' &&
                physicianInputValue?.length === 0 ? (
                    <>
                        <>
                            {isLasOption && data.length != 0 && showLoadMore ? (
                                <div
                                id="receivesets-accountphysiciantemplate-load-more"
                                    onClick={(e) => {
                                        // setAccount('');
                                        e.stopPropagation();
                                    }}
                                >
                                    <OptionalLoadMoreView
                                        height={
                                            showOptionLoader ? '150px' : '200px'
                                        }
                                        // some space is left after grey message area
                                        margin={
                                            showOptionLoader
                                                ? '10px 0 0 0'
                                                : '-2px 0 -8px 0'
                                        }
                                    >
                                        {showOptionLoader ? (
                                            <>
                                                <Spinner
                                                    id="receiveSets-accountPhysicianTemplate-optionalLoadMoreView-loadingSpinner"
                                                    animation="border"
                                                    variant="primary"
                                                    small={true}
                                                >
                                                    <p>
                                                        {t(
                                                            'receiveSets.ReceiveSetsLoc.AccountPhysicianTemplate.msg'
                                                        )}
                                                    </p>
                                                </Spinner>
                                            </>
                                        ) : (
                                            <>
                                                {/* text in two lines */}
                                                {isAllNotRecentUsed ? (
                                                    <p
                                                        style={{
                                                            fontSize: '12px',
                                                        }}
                                                    >
                                                        {t(
                                                            'receiveSets.ReceiveSetsLoc.AccountPhysicianTemplate.msg1'
                                                        )}
                                                        <br />
                                                        {t(
                                                            'receiveSets.ReceiveSetsLoc.AccountPhysicianTemplate.msg3'
                                                        )}
                                                    </p>
                                                ) : null}
                                                <p>
                                                    {t(
                                                        'scheduleSurgery.details.cantFindWhoYou'
                                                    )}
                                                    <br />
                                                    {t(
                                                        'receiveSets.ReceiveSetsLoc.AccountPhysicianTemplate.msg4'
                                                    )}
                                                </p>
                                                <button
                                                 id="receivesets-accountphysiciantemplate-load-more-button"
                                                    onClick={(e) => {
                                                        // setOptionaLoader(true);
                                                        e.stopPropagation();
                                                        onLoadMore(true);
                                                    }}
                                                >
                                                    {t(
                                                        'receiveSets.ReceiveSetsLoc.AccountPhysicianTemplate.msg5'
                                                    )}
                                                    {/* s is added */}
                                                    {/* {fieldname == 'physician'
                                                        ? 'Load All Physicians'
                                                        : 'Load All Accounts'} */}
                                                </button>
                                            </>
                                        )}
                                    </OptionalLoadMoreView>
                                </div>
                            ) : null}
                        </>
                    </>
                ) : null}
            </OuterContainer>
        </>
    );
}
